import {getField, updateField} from 'vuex-map-fields';
import InterestModule from './interest.module';
import NewsletterModule from './newsletter.module';

function initialState() {
    return {}
}

export default {
    namespaced: true,
    state:      initialState,
    getters:    {
        getField,
    },
    actions:    {
        async init({ dispatch }) {
            await dispatch('reset');
        },
        async reset({ commit }) {
            return commit('RESET');
        },
    },
    mutations:  {
        updateField,

        async RESET(state) {
            const s = initialState();
            Object.keys(s).forEach(key => state[key] = s[key]);
        }
    },
    modules:    {
        interest:   InterestModule,
        newsletter: NewsletterModule
    }
}
